import { OpportunitySchema } from '@features/opportunities/modules/core/models/schema-property-definition';
import {
  OptionsPropertyDefinition,
  StringPropertyDefinition
} from '@shared/models/schema-property-definition';

export namespace Task {
  export type Definition =
    | ({ type: 'Client' } & ClientSchemaDefinition)
    | ({ type: 'Opportunity' } & OpporutnitySchemaDefinition);

  export type ClientSchemaDefinition = {
    title: StringPropertyDefinition;
    due: StringPropertyDefinition;
    priority: OptionsPropertyDefinition;
    notes: StringPropertyDefinition;
  };

  export type OpporutnitySchemaDefinition = {
    title: OpportunitySchema.StringPropertyDefinition;
    due: OpportunitySchema.StringPropertyDefinition;
    priority: OpportunitySchema.OptionsPropertyDefinition;
    notes: OpportunitySchema.StringPropertyDefinition;
  };

  export function mapClientSchemaToDefinition(
    schema: ClientSchemaDefinition
  ): Definition {
    return {
      ...schema,
      type: 'Client'
    };
  }

  export function mapOpportunitySchemaToDefinition(
    schema: OpporutnitySchemaDefinition
  ): Definition {
    return {
      ...schema,
      type: 'Opportunity'
    };
  }

  export interface Model {
    id: string;
    status: string;
    title: string;
    due: string;
    priority: string;
    notes: string;
  }
}

export namespace ConsolidatedTask {
  export enum EntityType {
    Company = 'company',
    Individual = 'individual',
    Trust = 'trust',
    Lead = 'lead',
    Opportunity = 'opportunity'
  }

  /** Tag name string from the SQL projection (tagName only, no tagId). */
  export type TagName = string;

  export interface Model {
    completed: string | null;
    due: string;
    entityId: string;
    entityType: EntityType;
    priority: string;
    taskId: string;
    title: string;
    entityName: string;
    tags?: TagName[];
  }
}
